import { getGtmConsent, subscribeToGtmConsent } from "./gtmConsent";

interface DataLayerPush {
  event: string;
  [key: string]: unknown;
}

// Calls made before consent resolves (e.g. a tracker firing on mount, before
// the visitor has responded to the consent banner) are queued here rather
// than dropped, and flushed once consent is granted.
const pendingPushes: DataLayerPush[] = [];

function flushPendingPushes() {
  window.dataLayer = window.dataLayer || [];
  for (const data of pendingPushes.splice(0)) {
    window.dataLayer.push(data);
  }
}

if (typeof window !== "undefined") {
  subscribeToGtmConsent(() => {
    const consent = getGtmConsent();
    if (consent === true) flushPendingPushes();
    if (consent === false) pendingPushes.length = 0;
  });
}

/**
 * Pushes to window.dataLayer once GTM consent is granted. GTM's container
 * script only loads once consent is given (see GoogleTagManager.tsx) — pushing
 * before that lands in an array nothing is listening to and never reaches
 * GA4. Pushes made before consent resolves are queued and flushed once
 * granted, or discarded if the visitor declines.
 */
export function pushToDataLayer(data: DataLayerPush) {
  if (typeof window === "undefined") return;

  if (getGtmConsent() === true) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    return;
  }

  pendingPushes.push(data);
}
